import { createPinia, defineStore } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { AdminService } from 'gpcore-grpc/gpcore/api/admin/v1/rpc_pb';
import { CloudService } from 'gpcore-grpc/gpcore/api/cloud/v1/rpc_pb';
import { AuthService } from 'gpcore-grpc/gpcore/api/auth/v1/rpc_pb';
import { PaymentService } from 'gpcore-grpc/gpcore/api/payment/v1/rpc_pb';
import { CloudService as CloudServiceV2 } from 'gpcore-grpc/gpcore/api/cloud/v2/rpc_pb';

import Keycloak from 'keycloak-js';
import UniversalGrpcClient from 'gpcore-grpc/universal/UniversalGrpcClient';

declare module 'pinia' {
  export interface PiniaCustomProperties {
    keycloak: Keycloak;
    paymentService: UniversalGrpcClient<typeof PaymentService>;
    cloudService: UniversalGrpcClient<typeof CloudService>;
    adminService: UniversalGrpcClient<typeof AdminService>;
    authService: UniversalGrpcClient<typeof AuthService>;
    cloudServiceV2: UniversalGrpcClient<typeof CloudServiceV2>;
    config: {
      grpc: {
        api: string;
      };
    };
  }
}

const createGpCorePinia = (apiUrl: string, keycloak: Keycloak) =>
  createPinia()
    .use(piniaPluginPersistedstate)
    .use(() => ({
      keycloak,
      paymentService: new UniversalGrpcClient(PaymentService, apiUrl),
      cloudService: new UniversalGrpcClient(CloudService, apiUrl),
      adminService: new UniversalGrpcClient(AdminService, apiUrl),
      authService: new UniversalGrpcClient(AuthService, apiUrl),
      cloudServiceV2: new UniversalGrpcClient(CloudServiceV2, apiUrl),
      config: {
        grpc: {
          api: apiUrl,
        },
      },
    }));

export const useRootStore = defineStore('root', {});

export default createGpCorePinia;
